import { Link, useSearchParams } from "react-router-dom";
import Header from "../Header/Header";

export default function FailPage() {
  const [searchParams] = useSearchParams();
  const invoice = searchParams.get("invoice");
  const errorCode = searchParams.get("error_code");

  return (
    <>
      <Header variant="white" />
      <div className="min-h-screen flex items-center justify-center bg-[#F7F4EF] px-4">
        <div className="max-w-md w-full text-center">
          {/* Error Icon */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-100 flex items-center justify-center">
            <svg
              className="w-10 h-10 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
            Payment Failed
          </h1>

          {/* Message */}
          <p className="text-gray-600 mb-6">
            Unfortunately, your payment could not be processed. Please try again or use a different payment method.
          </p>

          {/* Invoice Info */}
          {invoice && (
            <div className="bg-white rounded-lg p-4 mb-6 text-left">
              <p className="text-sm text-gray-500 mb-1">Order Reference</p>
              <p className="font-mono text-sm text-gray-800 break-all">{invoice}</p>
              {errorCode && (
                <>
                  <p className="text-sm text-gray-500 mt-3 mb-1">Error Code</p>
                  <p className="font-mono text-sm text-red-600">{errorCode}</p>
                </>
              )}
            </div>
          )}

          {/* Action Buttons */}
          <div className="space-y-3">
            <Link
              to="/checkout"
              className="block w-full py-3 px-6 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors font-medium"
            >
              Try Again
            </Link>
            
            <Link
              to="/cart"
              className="block w-full py-3 px-6 bg-white text-black border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              Return to Cart
            </Link>

            <Link
              to="/"
              className="block w-full py-3 px-6 text-gray-600 hover:text-black transition-colors"
            >
              ← Back to Home
            </Link>
          </div>

          {/* Help Text */}
          <p className="mt-8 text-sm text-gray-500">
            Need help?{" "}
            <a href="mailto:support@bodiosyakdown.com" className="text-black underline">
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </>
  );
}